<template>
   <!-- Loading -->
  <LoadingDiv v-if="isLoading" />

  <!-- Display -->
  <template v-else>
    <!-- Search -->
    <nav class="white" v-if="benefits?.length || search">
      <div class="nav-wrapper">
        <form method="POST" action="#">
          <div class="input-field blue-text text-darken-2">
            <input type="search" v-model="searchItem" @focus="handleClearSearch()"
              placeholder="Search Benefits by Item or Description" />
            <label class="label-icon" for="search"><i class="material-icons black-text">search</i></label>
            <i class="material-icons white-text orange" @click="handleClearSearch()" v-if="searchItem">clear</i>
          </div>
        </form>
      </div>
    </nav>
    <div class="progress down" v-if="isSearching">
      <div class="indeterminate"></div>
    </div>


    <div class="card z-depth-0" v-if="benefits?.length">
      <div class="card-panel z-depth-0" v-for="benefit in benefits" :key="benefit.id">
        <div class="row">
          <div class="col s12">
            <h6>
              {{ benefit.item }}
              <span class="secondary-content chip">{{
                benefit.description
              }}</span>
            </h6>
          </div>
        </div>
      </div>
      <br />
    </div>

    <div class="section center" v-if="!benefits?.length">
      <div class="card z-depth-0">
            <h6 class="chip yellow">No Benefits <em>found</em>...</h6>
      </div>
    </div>

    <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
  </template>
</template>

<script>
import { ref, onMounted, computed, watchEffect } from "vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import getItemsOfItemsOfItems from "@/composables/getItemsOfItemsOfItems";
import LoadingDiv from "@/components/LoadingDiv.vue";

export default {
  name: "ShowBenefitComponent",
  components: { PaginationDiv, LoadingDiv },
  props: ["pid", "cid"],
  setup(props) {
    const isLoading = ref(true);
    const isSearching = ref(false);
    const response = ref(null);
    const error = ref(null);
    const search = ref(null);
    const searchItem = ref(null);
    const currUrl = ref(null);
    const currHook = ref(null);

    // get function
    const getItemsFromApi = (table, id1, id2) => {
      (async () => {
        const { res, err } = await getItemsOfItemsOfItems(table, id1, id2);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // end loading
        isLoading.value = false;
        // end searching
        isSearching.value = false;
      })();
    };

    // starter
    onMounted(() => {
      // get encounter
      getEncounter();
    });

    // get encounters
    const getEncounter = () => {
      // set current Url
      currUrl.value = "benefits/plan/search";
      // set current Hook
      currHook.value = "?";
      // get items from function
      getItemsFromApi(currUrl.value, props.pid, props.cid);
    }

    // restart
    const handleClearSearch = () => {
      if (searchItem.value) {
        // start searching
        isSearching.value = true;
        // null search
        searchItem.value = null;
        // get encounters
        getEncounter();
      }
    };

    // switch page
    const handlePage = (page) => {
      // start loading
      isLoading.value = true;
      // get new page items from function
      getItemsFromApi(currUrl.value, props.pid, `${props.cid}${currHook.value}page=${page}`);
      // move up
      // context.emit("moveUp", true);
    };

    // searcher
    const searcher = (val) => {
      // wake search
      search.value = true;
      // start searching
      isSearching.value = true;
      // set current Url
      currUrl.value = "benefits/plan/search";
      // set future Hook
      currHook.value = `?q=${val}&`;
      // search
      getItemsFromApi(currUrl.value, props.pid, `${props.cid}${currHook.value}`);
    }

    // search watcher
    watchEffect(() => {
      if (searchItem.value) {
        // search
        searcher(searchItem.value);
      } else {
        // get encounters
        getEncounter();
      }
    });

    // output results
    const benefits = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data;
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    return {
      isLoading,
      isSearching,
      handleClearSearch,
      handlePage,
      search,
      searchItem,
      currUrl,
      currHook,
      error,
      benefits,
      allPages,
    };
  },
};
</script>

<style scoped>
.progress {
  margin-top: -15px;
}
.down {
  margin-top: 0px;
}
</style>